import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import * as constants from 'src/app/models/constants/constants'

@Injectable({
    providedIn: 'root'
})
export class UtilService {

    private messageSource = new BehaviorSubject('');

    private boolRequisitos = new BehaviorSubject(false);
    private boolComposicao = new BehaviorSubject(false);
    private boolParams = new BehaviorSubject(false);
    private boolPricing = new BehaviorSubject(false);
    private boolCronograma = new BehaviorSubject(false);

    currentMessage = this.messageSource.asObservable();

    currentBoolRequisitos = this.boolRequisitos.asObservable();
    currentBoolComposicao = this.boolComposicao.asObservable();
    currentBoolParams = this.boolParams.asObservable();
    currentBoolPricing = this.boolPricing.asObservable();
    currentBoolCronograma = this.boolCronograma.asObservable();    

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    setMessage(message: string) {
        this.messageSource.next(message ? message : '');
    }

    setBoolRequisitos(bool: boolean) {
        this.boolRequisitos.next(bool);
    }

    setBoolComposicao(bool: boolean) {
        this.boolComposicao.next(bool);
    }

    setBoolParams(bool: boolean) {
        this.boolParams.next(bool);
    }

    setBoolPricing(bool: boolean) {
        this.boolPricing.next(bool);
    }

    setBoolCronograma(bool: boolean) {
        this.boolCronograma.next(bool);
    }

    getUserId() {
        const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
        return (user && user !== undefined) ? user.id : 0;
    }

    getUser() {
        const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
        return (user && user !== undefined) ? user : null;
    }

    isAdmin() {
        const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));

        const administrator = (user.perfil.find(p => p.id === constants.PerfilConstants.ID_PERFIL_ADMINISTRADOR));

        return (administrator ? true : false);
    }

    isDelivery() {
        const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));

        const delivery = (user.perfil.find(p => p.id === constants.PerfilConstants.ID_PERFIL_DELIVERY));

        return (delivery ? true : false);
    }

    redirToHome() {
        this.router.navigate(['/painel-geral']);
    }

    logOut() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }

    isSolution() {
        const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));

        const solution = (user.perfil.find(p => p.id === constants.PerfilConstants.ID_PERFIL_SOLUTION));

        return (solution ? true : false);
    }

    getUnidadeId() {
        const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
        return (user && user !== undefined) ? user.unidadeId : 0;
    }

    redirectAcessoNegado() {
        this.router.navigate(['/access-denied']);
    }
}